import { MaskitoElement } from "@maskito/core";
import { maskitoCaretGuard } from "@maskito/kit";

export function setCursorBeforeSuffixPlugin(
  postfix: string,
  verbose?: boolean
): (element: MaskitoElement) => () => void {
  return function (element: MaskitoElement) {
    function setCursorBeforeSuffix() {
      if (verbose) console.group("[setCursorBeforeSuffix]");
      const suffixIndex = element.value.indexOf(postfix);
      if (verbose)
        console.debug(
          "selection",
          element.selectionStart,
          element.selectionEnd
        );
      if ((element.selectionEnd ?? 0) > suffixIndex) {
        element.selectionEnd = suffixIndex;
        if ((element.selectionStart ?? 0) > element.selectionEnd) {
          element.selectionStart = element.selectionEnd;
        }
      }
      if (verbose) console.groupEnd();
    }
    element.addEventListener("selectionchange", setCursorBeforeSuffix);

    return () => {
      element.removeEventListener("selectionchange", setCursorBeforeSuffix);
    };
  };
}

export function setCursorBeforeSuffixPluginV2(postfix: string) {
  return maskitoCaretGuard((value) => [0, value.length - postfix.length]);
}

export type ReplaceDefaultOnInputPluginOptions = {
  prefix?: string;
  suffix?: string;
  verbose?: string;
  default: string;
};
export function replaceDefaultOnInputPlugin(
  opts: ReplaceDefaultOnInputPluginOptions
): (element: MaskitoElement) => () => void {
  return function (element: MaskitoElement) {
    function replaceDefaultOnInput() {
      if (opts.verbose) console.group("[replaceDefaultOnInputPlugin]");
      let suffixIndex = element.value.length;
      if (opts.suffix) {
        suffixIndex = element.value.indexOf(opts.suffix);
      }
      let prefixIndex = 0;
      if (opts.prefix) {
        element.value.indexOf(opts.prefix) + opts.prefix.length;
      }
      let inputValue = element.value.slice(prefixIndex, suffixIndex);
      let defaultIndex = element.value.indexOf(opts.default);
      if (opts.verbose) {
        console.debug("[replaceDefaultOnInputPlugin]", {
          prefixIndex,
          suffixIndex,
          defaultIndex,
        });
      }
      if (inputValue === opts.default) {
        if (opts.verbose)
          console.debug(
            "[replaceDefaultOnInputPlugin] inputValue matched default, moving selection",
            {
              default: opts.default,
              inputValue,
            }
          );
        element.selectionStart = defaultIndex;
      }

      if (opts.verbose) console.groupEnd();
    }
    element.addEventListener("keydown", replaceDefaultOnInput);

    return () => {
      element.removeEventListener("keydown", replaceDefaultOnInput);
    };
  };
}

export function setCursorAfterPrefixPlugin(
  prefix: string,
  verbose?: boolean
): (element: MaskitoElement) => () => void {
  return function (element) {
    function setCursorAfterPrefix() {
      if (verbose) console.group("[setCursorAfterPrefix]");
      const prefixEndIndex = element.value.indexOf(prefix) + prefix.length;
      if (verbose)
        console.log("before", element.selectionStart, prefixEndIndex);

      if ((element.selectionStart ?? 0) < prefixEndIndex) {
        element.selectionStart = prefixEndIndex;
        if (verbose)
          console.log("after", element.selectionStart, prefixEndIndex);

        if ((element.selectionEnd ?? 0) < element.selectionStart) {
          element.selectionEnd = element.selectionStart;
        }
      }
      if (verbose) console.groupEnd();
    }
    element.addEventListener("selectionchange", setCursorAfterPrefix);
    return () => {
      element.removeEventListener("selectionchange", setCursorAfterPrefix);
    };
  };
}
